export default __webpack_public_path__ + "static/media/explore8.8074d2b3.png";